export default __webpack_public_path__ + "static/media/solution_90.bedee04e.png";